// RB-MY01-PalmGarden.web/src/components/Footer.tsx
import React from 'react';
import '../styles/footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-container">
        <p>&copy; {new Date().getFullYear()} Palm Garden. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 